import { ErrorHandler, Injectable, inject } from '@angular/core';
import { ChunkReloadService } from '../services/chunk-reload.service';

/**
 * Sends lazy-chunk load failures to the reload recovery and otherwise keeps
 * the previous behaviour of logging unexpected errors.
 */
@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  private chunkReload = inject(ChunkReloadService);

  handleError(error: unknown): void {
    if (this.chunkReload.isChunkLoadError(error)) {
      this.chunkReload.handle(error);
      return;
    }
    console.error(error);
  }
}
